import axios from 'axios'
import urls from './urls'
import querystring from 'querystring'

const locations = async function (input) {
  try {
    let filters = {
      page: 0,
      size: 10,
      name: input
    }
    const res = await axios.get(urls.locationList + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const vehicles = async function (input) {
  try {
    let filters = {
      page: 0,
      size: 10,
      name: input
    }
    const res = await axios.get(urls.vehicleList + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch available vehicle numbers for fixed price assignment
 * @param {Number} id fixedPrice Id
 */
const vehicleNumbers = async function (clientId, fixedPriceId) {
  try {
    console.log('TCL: clientId, fixedPriceId', urls.availableVehicleNo(clientId, fixedPriceId))
    let res = await axios.get(urls.availableVehicleNo(clientId, fixedPriceId))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const customers = async function (input) {
  try {
    let filters = {
      page: 0,
      size: 10,
      name: input,
      type: 'SHIPPER'
    }
    let res = await axios.get(urls.clientList + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const transporters = async function (input) {
  try {
    let filters = {
      page: 0,
      size: 10,
      name: input,
      type: 'TRANSPORTER'
    }
    let res = await axios.get(urls.clientList + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const provinces = async function (input) {
  try {
    let filters = {
      page: 0,
      size: 10,
      name: input,
    }
    let res = await axios.get(urls.provinceList + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}
// get kodya
const cities = async function (input, provinceId) {
  try {
    let filters = {
      page: 0,
      size: 10,
      name: input,
      provinceId
    }
    let res = await axios.get(urls.cityList + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

// get kecamatan
const districts = async function (input, cityId) {
  try {
    let filters = {
      page: 0,
      size: 10,
      name: input,
      cityId
    }
    let res = await axios.get(urls.districtList + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

// kelurahan
const subDistricts = async function (input, districtId) {
  try {
    let filters = {
      page: 0,
      size: 10,
      name: input,
      districtId
    }
    let res = await axios.get(urls.subDistrictList + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const urbanVillages = async function (input, subDistrictId) {
  try {
    let filters = {
      page: 0,
      size: 10,
      name: input,
      subDistrictId
    }
    let res = await axios.get(urls.urbanVillageList + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const locationOriginByClient = async function (input, clientId) {
  try {
    let filters = {
      page: 0,
      size: 10,
      name: input,
      clientId: clientId
    }
    const res = await axios.get(urls.locationOrigin + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const locationDestinationByClient = async function (input, clientId) {
  try {
    let filters = {
      page: 0,
      size: 10,
      name: input,
      clientId: clientId
    }
    const res = await axios.get(urls.locationDestination + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch location according active orders
 * @param {String} input user input search text
 * @param {String} type locationtype; destination/origin
 */
const availableLocationsFromOrders = async function (input, type) {
  try {
    let filters = {
      page: 0,
      size: 10,
      name: input,
      type
    }
    const url = urls.locationsFromOrders + '?' + querystring.stringify(filters)
    console.log('availableLocationsFromOrders -> url', url)
    const res = await axios.get(url)
    console.log('availableLocationsFromOrders -> res.data', res.data)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch transport available for order filter
 * @param {String} input transport input search text
 */
const availableVehiclesFromOrders = async function (input) {
  try {
    let filters = {
      page: 0,
      size: 10,
      no: input,
    }
    const url = urls.vehiclesFromOrders + '?' + querystring.stringify(filters)
    const res = await axios.get(url)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

export {
  locations,
  vehicles,
  vehicleNumbers,
  customers,
  transporters,
  provinces,
  cities,
  districts,
  subDistricts,
  urbanVillages,
  locationDestinationByClient,
  locationOriginByClient,
  availableLocationsFromOrders,
  availableVehiclesFromOrders,
}
